<template>
  <v-form
    ref="form"
    v-model="isFormValid"
    class="pt-2"
  >
    <TaskInput
      v-model="formValues.task"
      dense
      outlined
    ></TaskInput>
    <v-select
      v-model="formValues.pia"
      :items="statusItems"
      dense
      outlined
      :label="$t('ITNS (Y/N)')"
    ></v-select>
    <v-textarea
      v-model="formValues.applicable_documents"
      clearable
      dense
      outlined
      :label="$t('Applicable documents')"
      rows="5"
    />
    <v-text-field
      clearable
      @input="handleInput"
      type="text"
      v-model="formValues.doc_rev"
      :label="$t('Doc rev.')"
      dense
      outlined
    />
    <v-row class="mt-0 d-flex align-baseline mb-4">
      <v-col
        cols="12"
        md="4"
        class="primary--text font-weight-bold"
      >
        {{ $t("Performer") }}
        <avs-button
          color="blue white--text"
          iconI="mdi-upload"
          class="mb-5"
          @click="handleUpload('performer')"
          :spantext="$t('actions.upload', { entity: $tc('commons.picture', 1).toLowerCase() })"
          ><template v-slot:name>{{
            $t("actions.upload", { entity: $tc("commons.picture", 1).toLowerCase() })
          }}</template>
        </avs-button>
        <v-row>
          <v-col
            cols="12"
            sm="9"
            md="9"
            v-if="performerPicture"
          >
            <v-card class="mx-auto overflow-hidden">
              <div
                @mouseleave="performerPicture.hover = false"
                @mouseenter="performerPicture.hover = true"
                :style="{ position: 'relative' }"
              >
                <v-fade-transition>
                  <v-overlay
                    v-show="performerPicture.hover"
                    absolute
                    color="primary"
                    z-index="99"
                  >
                    <PicturePreview v-model="performerPicture.file_url">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          text
                          v-on="on"
                          :attrs="attrs"
                        >
                          <v-icon left>mdi-eye</v-icon>
                          {{ $t("commons.preview") }}
                        </v-btn>
                      </template>
                    </PicturePreview>
                  </v-overlay>
                </v-fade-transition>
                <v-img
                  :src="performerPicture.file_url"
                  height="150"
                  width="250"
                ></v-img>
              </div>
              <avs-deleteButton
                @click.stop="handleOpenDeleteDialog('performer', performerPicture)"
                :spantext="
                  $t('actions.delete', { entity: $tc('commons.picture', 1).toLowerCase() })
                "
              />
            </v-card>
          </v-col>
        </v-row>
        <input
          v-show="false"
          type="file"
          accept="image/*"
          @change="handleChange('performer', $event)"
          ref="uploadInput_performer"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
        class="primary--text font-weight-bold"
      >
        {{ $t("Quality Control") }}
        <avs-button
          color="blue white--text"
          iconI="mdi-upload"
          class="mb-5"
          @click="handleUpload('quality')"
          :spantext="$t('actions.upload', { entity: $tc('commons.picture', 1).toLowerCase() })"
          ><template v-slot:name>{{
            $t("actions.upload", { entity: $tc("commons.picture", 1).toLowerCase() })
          }}</template>
        </avs-button>
        <v-row>
          <v-col
            cols="12"
            sm="9"
            md="9"
            v-if="qualityPicture"
          >
            <v-card class="mx-auto overflow-hidden">
              <div
                @mouseleave="qualityPicture.hover = false"
                @mouseenter="qualityPicture.hover = true"
                :style="{ position: 'relative' }"
              >
                <v-fade-transition>
                  <v-overlay
                    v-show="qualityPicture.hover"
                    absolute
                    color="primary"
                    z-index="99"
                  >
                    <PicturePreview v-model="qualityPicture.file_url">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          text
                          v-on="on"
                          :attrs="attrs"
                        >
                          <v-icon left>mdi-eye</v-icon>
                          {{ $t("commons.preview") }}
                        </v-btn>
                      </template>
                    </PicturePreview>
                  </v-overlay>
                </v-fade-transition>
                <v-img
                  :src="qualityPicture.file_url"
                  height="150"
                  width="250"
                ></v-img>
              </div>
              <avs-deleteButton
                @click.stop="handleOpenDeleteDialog('quality', qualityPicture)"
                :spantext="
                  $t('actions.delete', { entity: $tc('commons.picture', 1).toLowerCase() })
                "
              />
            </v-card>
          </v-col>
        </v-row>
        <input
          v-show="false"
          type="file"
          accept="image/*"
          @change="handleChange('quality', $event)"
          ref="uploadInput_quality"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
        class="primary--text font-weight-bold"
      >
        {{ $t("Technical Control Performer") }}
        <avs-button
          color="blue white--text"
          iconI="mdi-upload"
          class="mb-5"
          @click="handleUpload('technical')"
          :spantext="$t('actions.upload', { entity: $tc('commons.picture', 1).toLowerCase() })"
          ><template v-slot:name>{{
            $t("actions.upload", { entity: $tc("commons.picture", 1).toLowerCase() })
          }}</template>
        </avs-button>
        <v-row>
          <v-col
            cols="12"
            sm="9"
            md="9"
            v-if="technicalPicture"
          >
            <v-card class="mx-auto overflow-hidden">
              <div
                @mouseleave="technicalPicture.hover = false"
                @mouseenter="technicalPicture.hover = true"
                :style="{ position: 'relative' }"
              >
                <v-fade-transition>
                  <v-overlay
                    v-show="technicalPicture.hover"
                    absolute
                    color="primary"
                    z-index="99"
                  >
                    <PicturePreview v-model="technicalPicture.file_url">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          text
                          v-on="on"
                          :attrs="attrs"
                        >
                          <v-icon left>mdi-eye</v-icon>
                          {{ $t("commons.preview") }}
                        </v-btn>
                      </template>
                    </PicturePreview>
                  </v-overlay>
                </v-fade-transition>
                <v-img
                  :src="technicalPicture.file_url"
                  height="150"
                  width="250"
                ></v-img>
              </div>
              <avs-deleteButton
                @click.stop="handleOpenDeleteDialog('technical', technicalPicture)"
                :spantext="
                  $t('actions.delete', { entity: $tc('commons.picture', 1).toLowerCase() })
                "
              />
            </v-card>
          </v-col>
        </v-row>
        <input
          v-show="false"
          type="file"
          accept="image/*"
          @change="handleChange('technical', $event)"
          ref="uploadInput_technical"
        />
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row class="mt-4 d-flex align-baseline mb-4">
      <v-col
        cols="12"
        md="6"
        class="primary--text font-weight-bold"
      >
        {{ $t("A") }}
        <QualityPointInput
          v-model="formValues.quality_point_a"
          @input="handleInput"
          :label="$t('PIA')"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
        class="primary--text font-weight-bold text-center"
      >
        {{ $t("Partie A") }}
        <avs-button
          color="blue white--text"
          iconI="mdi-upload"
          class="mb-5"
          @click="handleUpload('partA')"
          :spantext="$t('actions.upload', { entity: $tc('commons.picture', 1).toLowerCase() })"
          ><template v-slot:name>{{
            $t("actions.upload", { entity: $tc("commons.picture", 1).toLowerCase() })
          }}</template>
        </avs-button>
        <v-row>
          <v-col
            cols="12"
            sm="9"
            md="9"
            v-if="partAPicture"
          >
            <v-card class="mx-auto overflow-hidden">
              <div
                @mouseleave="partAPicture.hover = false"
                @mouseenter="partAPicture.hover = true"
                :style="{ position: 'relative' }"
              >
                <v-fade-transition>
                  <v-overlay
                    v-show="partAPicture.hover"
                    absolute
                    color="primary"
                    z-index="99"
                  >
                    <PicturePreview v-model="partAPicture.file_url">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          text
                          v-on="on"
                          :attrs="attrs"
                        >
                          <v-icon left>mdi-eye</v-icon>
                          {{ $t("commons.preview") }}
                        </v-btn>
                      </template>
                    </PicturePreview>
                  </v-overlay>
                </v-fade-transition>
                <v-img
                  :src="partAPicture.file_url"
                  height="150"
                  width="250"
                ></v-img>
              </div>
              <avs-deleteButton
                @click.stop="handleOpenDeleteDialog('partA', partAPicture)"
                :spantext="
                  $t('actions.delete', { entity: $tc('commons.picture', 1).toLowerCase() })
                "
              />
            </v-card>
          </v-col>
        </v-row>
        <input
          v-show="false"
          type="file"
          accept="image/*"
          @change="handleChange('partA', $event)"
          ref="uploadInput_partA"
        />
      </v-col>
    </v-row>
    <v-row class="mt-4 d-flex align-baseline mb-4">
      <v-col
        cols="12"
        md="6"
        class="primary--text font-weight-bold"
      >
        {{ $t("B") }}
        <QualityPointInput
          v-model="formValues.quality_point_a"
          @input="handleInput"
          :label="$t('PIA')"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
        class="primary--text font-weight-bold text-center"
      >
        {{ $t("Partie B") }}
        <avs-button
          color="blue white--text"
          iconI="mdi-upload"
          class="mb-5"
          @click="handleUpload('partB')"
          :spantext="$t('actions.upload', { entity: $tc('commons.picture', 1).toLowerCase() })"
          ><template v-slot:name>{{
            $t("actions.upload", { entity: $tc("commons.picture", 1).toLowerCase() })
          }}</template>
        </avs-button>
        <v-row>
          <v-col
            cols="12"
            sm="9"
            md="9"
            v-if="partBPicture"
          >
            <v-card class="mx-auto overflow-hidden">
              <div
                @mouseleave="partBPicture.hover = false"
                @mouseenter="partBPicture.hover = true"
                :style="{ position: 'relative' }"
              >
                <v-fade-transition>
                  <v-overlay
                    v-show="partBPicture.hover"
                    absolute
                    color="primary"
                    z-index="99"
                  >
                    <PicturePreview v-model="partBPicture.file_url">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          text
                          v-on="on"
                          :attrs="attrs"
                        >
                          <v-icon left>mdi-eye</v-icon>
                          {{ $t("commons.preview") }}
                        </v-btn>
                      </template>
                    </PicturePreview>
                  </v-overlay>
                </v-fade-transition>
                <v-img
                  :src="partBPicture.file_url"
                  height="150"
                  width="250"
                ></v-img>
              </div>
              <avs-deleteButton
                @click.stop="handleOpenDeleteDialog('partB', partBPicture)"
                :spantext="
                  $t('actions.delete', { entity: $tc('commons.picture', 1).toLowerCase() })
                "
              />
            </v-card>
          </v-col>
        </v-row>
        <input
          v-show="false"
          type="file"
          accept="image/*"
          @change="handleChange('partB', $event)"
          ref="uploadInput_partB"
        />
      </v-col>
    </v-row>
    <v-row class="mt-4 d-flex align-baseline mb-4">
      <v-col
        cols="12"
        md="6"
        class="primary--text font-weight-bold"
      >
        {{ $t("C") }}
        <QualityPointInput
          v-model="formValues.quality_point_a"
          @input="handleInput"
          :label="$t('PIA')"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
        class="primary--text font-weight-bold text-center"
      >
        {{ $t("Partie C") }}
        <avs-button
          color="blue white--text"
          iconI="mdi-upload"
          class="mb-5"
          @click="handleUpload('partC')"
          :spantext="$t('actions.upload', { entity: $tc('commons.picture', 1).toLowerCase() })"
          ><template v-slot:name>{{
            $t("actions.upload", { entity: $tc("commons.picture", 1).toLowerCase() })
          }}</template>
        </avs-button>
        <v-row>
          <v-col
            cols="12"
            sm="9"
            md="9"
            v-if="partCPicture"
          >
            <v-card class="mx-auto overflow-hidden">
              <div
                @mouseleave="partCPicture.hover = false"
                @mouseenter="partCPicture.hover = true"
                :style="{ position: 'relative' }"
              >
                <v-fade-transition>
                  <v-overlay
                    v-show="partCPicture.hover"
                    absolute
                    color="primary"
                    z-index="99"
                  >
                    <PicturePreview v-model="partCPicture.file_url">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          text
                          v-on="on"
                          :attrs="attrs"
                        >
                          <v-icon left>mdi-eye</v-icon>
                          {{ $t("commons.preview") }}
                        </v-btn>
                      </template>
                    </PicturePreview>
                  </v-overlay>
                </v-fade-transition>
                <v-img
                  :src="partCPicture.file_url"
                  height="150"
                  width="250"
                ></v-img>
              </div>
              <avs-deleteButton
                @click.stop="handleOpenDeleteDialog('partC', partCPicture)"
                :spantext="
                  $t('actions.delete', { entity: $tc('commons.picture', 1).toLowerCase() })
                "
              />
            </v-card>
          </v-col>
        </v-row>
        <input
          v-show="false"
          type="file"
          accept="image/*"
          @change="handleChange('partC', $event)"
          ref="uploadInput_partC"
        />
      </v-col>
    </v-row>
    <v-row class="mt-4 d-flex align-baseline mb-4">
      <v-col
        cols="12"
        md="6"
        class="primary--text font-weight-bold"
      >
        {{ $t("D") }}
        <QualityPointInput
          v-model="formValues.quality_point_a"
          @input="handleInput"
          :label="$t('PIA')"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
        class="primary--text font-weight-bold text-center"
      >
        {{ $t("Partie D") }}
        <avs-button
          color="blue white--text"
          iconI="mdi-upload"
          class="mb-5"
          @click="handleUpload('partD')"
          :spantext="$t('actions.upload', { entity: $tc('commons.picture', 1).toLowerCase() })"
          ><template v-slot:name>{{
            $t("actions.upload", { entity: $tc("commons.picture", 1).toLowerCase() })
          }}</template>
        </avs-button>
        <v-row>
          <v-col
            cols="12"
            sm="9"
            md="9"
            v-if="partDPicture"
          >
            <v-card class="mx-auto overflow-hidden">
              <div
                @mouseleave="partDPicture.hover = false"
                @mouseenter="partDPicture.hover = true"
                :style="{ position: 'relative' }"
              >
                <v-fade-transition>
                  <v-overlay
                    v-show="partDPicture.hover"
                    absolute
                    color="primary"
                    z-index="99"
                  >
                    <PicturePreview v-model="partDPicture.file_url">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          text
                          v-on="on"
                          :attrs="attrs"
                        >
                          <v-icon left>mdi-eye</v-icon>
                          {{ $t("commons.preview") }}
                        </v-btn>
                      </template>
                    </PicturePreview>
                  </v-overlay>
                </v-fade-transition>
                <v-img
                  :src="partDPicture.file_url"
                  height="150"
                  width="250"
                ></v-img>
              </div>
              <avs-deleteButton
                @click.stop="handleOpenDeleteDialog('partD', partDPicture)"
                :spantext="
                  $t('actions.delete', { entity: $tc('commons.picture', 1).toLowerCase() })
                "
              />
            </v-card>
          </v-col>
        </v-row>
        <input
          v-show="false"
          type="file"
          accept="image/*"
          @change="handleChange('partD', $event)"
          ref="uploadInput_partD"
        />
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row class="mt-4 d-flex align-baseline mb-4">
      <v-col
        cols="12"
        md="6"
        class="primary--text font-weight-bold"
      >
        <v-select
          v-model="formValues.record"
          :items="statusItems"
          dense
          outlined
          :label="$t('Record (Y/N)')"
        ></v-select>
      </v-col>
      <v-col
        cols="12"
        md="6"
        class="primary--text font-weight-bold"
      >
        <v-text-field
          clearable
          @input="handleInput"
          type="text"
          v-model="formValues.record_reference"
          :label="$t('Record référence')"
          dense
          outlined
        />
      </v-col>
    </v-row>
    <v-textarea
      v-model="formValues.observation"
      clearable
      dense
      outlined
      :label="$t('NCR/DR Observation')"
      rows="5"
    />
    <avs-deleteDialog
      v-model="deleteDialogIsOpen"
      @cancel="handleCancel"
      @delete="handleDelete"
      resource="signature picture"
    />
  </v-form>
</template>

<script>
import _ from "lodash"

import { mkPcqDsi } from "@/utils/datamodels"
import { toDatetime } from "@/utils/datetime"
import { required, dateCompare, imageValidator } from "@/utils/validator"
import { YES_NO_ITEMS, SIGNATURES_ITEMS } from "@/utils/consts"
import { TaskInput } from "@/components"

export default {
  name: "PcqDsiForm",
  components: {
    // DatetimePicker: () => import("@/components/inputs/DatetimePicker.vue"),
    QualityPointInput: () => import("@/components/inputs/QualityPointInput.vue"),
    PicturePreview: () => import("../non-conformity/NonConformityPicturePreview.vue"),
    TaskInput
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    validateCounter: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isFormValid: true,
      formValues: mkPcqDsi(),
      performerPicture: null,
      qualityPicture: null,
      technicalPicture: null,
      partAPicture: null,
      partBPicture: null,
      partCPicture: null,
      partDPicture: null,
      deleteDialogIsOpen: false
    }
  },
  computed: {
    rules() {
      return {
        name: [required],
        status: [required],
        start_date: [required],
        end_date: [
          required,
          () => dateCompare(this.formValues.start_date, this.formValues.end_date)
        ]
      }
    },
    statusItems() {
      return YES_NO_ITEMS
    },
    signatureItems() {
      return SIGNATURES_ITEMS
    }
  },
  methods: {
    formatDatetime(value) {
      return value ? toDatetime(value) : "-"
    },
    handleInput() {
      this.$emit("input", this.formValues)
    },
    handleUpload(type) {
      switch (type) {
        case "performer":
          this.$refs.uploadInput_performer.click()
          break
        case "quality":
          this.$refs.uploadInput_quality.click()
          break
        case "technical":
          this.$refs.uploadInput_technical.click()
          break
      }
    },
    handleCancel() {
      this.deleteDialogIsOpen = false
    },
    handleDelete() {
      // eslint-disable-next-line no-unused-vars
      const { type, item } = this.selectedItem
      this[type + "Picture"] = null
      this.deleteDialogIsOpen = false
      this.$store.commit("app/message", {
        msg: this.$t("messages.information.signature"),
        color: "success"
      })
    },
    handleChange(type, event) {
      const files = Array.from(event.target.files)
      files.forEach(file => {
        if (imageValidator(file)) {
          let reader = new FileReader()
          reader.onload = () => {
            this[type + "Picture"] = {
              file_url: reader.result,
              label: "",
              hover: false,
              removed: false
            }
          }
          reader.readAsDataURL(file)
        }
      })
    },
    handleOpenDeleteDialog(type, item) {
      this.deleteDialogIsOpen = true
      this.selectedItem = { type, item }
    }
  },
  mounted() {
    if (this.value) this.formValues = _.cloneDeep(this.value)
  },
  watch: {
    validateCounter(newValue) {
      this.$refs["form"].validate()
    },
    isFormValid(newValue) {
      this.$emit("validated", newValue)
    },
    value(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.formValues = _.cloneDeep(this.value)
      }
    }
  }
}
</script>
